<div class="profile-bar" [class.admin-panel]="!showTitle" [class.title-only-mode]="showOnlyTitle" [class.detail-mode]="isDetailPage" [class.avatar-only]="avatarOnly" [class.brand-only]="hideTitle">
    @if (!avatarOnly) {
        @if (showOnlyTitle) {
            <h2 class="page-title-only">{{ pageTitle }}</h2>
        } @else {
            @if (isDetailPage) {
                <app-button
                    icon="ArrowLeft"
                    variant="icon-ghost"
                    size="small"
                    [ariaLabel]="'common.actions.back' | transloco"
                    (onClick)="backClick.emit()"
                    class="back-button"
                ></app-button>
            } @else {
                <img [src]="brandLogo" [alt]="'common.a11y.logo' | transloco" class="logo">
                <img [src]="brandWordmark" [alt]="brandName" class="logo-wordmark">
            }
            @if (!hideTitle) {
                <h5 class="page-title">{{ pageTitle }}</h5>
            }
        }

        <!-- Tabs of the page (e.g. "Todos / Mis Pedidos"), published by the page; on mobile the
             page renders them itself (the CSS display:none loses against the pill tabs' :host !important) -->
        @if (pageTabs && !viewport.isMobileView()) {
            <app-tabs
                class="page-tabs"
                [tabHeaders]="pageTabs.tabs"
                [selectedTab]="pageTabs.selected"
                (selectedTabChange)="onPageTabChange($event)"
                type="pill"
                size="medium"
                [fitContent]="true"
            ></app-tabs>
        }

        @if (isDashboard) {
            <app-period-picker class="period-tabs"></app-period-picker>
        }
    }

    <div class="icon-bar">
        <!-- Main action of the page (e.g. "Nuevo Pedido"), published by its table -->
        @if (pageAction && !avatarOnly) {
            <app-button
                class="page-action"
                [label]="pageAction.label"
                [icon]="pageAction.icon"
                size="medium"
                (onClick)="pageAction.onClick($event.target)"
            ></app-button>
        }

        @if (!hideProfileButton && userName) {
            <div class="profile-dropdown">
                <button type="button" class="avatar-button" aria-haspopup="menu" [attr.aria-expanded]="showProfileMenu" (click)="toggleProfileMenu($event)" #avatarButton>
                    <img [src]="userSticker" alt="" class="user-sticker" />
                    <span class="avatar-text">
                        <span class="avatar-name">{{ userName }}</span>
                        <!-- Balance on the providers' panels (admins) -->
                        @for (provider of providerBalance.balances(); track provider.id) {
                            <span
                                class="provider-balance"
                                [class.provider-balance--low]="provider.balance !== null && provider.balance < lowBalance"
                                [title]="('common.providerBalance' | transloco) + ' · ' + provider.name"
                            >
                                <lucide-icon name="Wallet" [size]="14" aria-hidden="true"></lucide-icon>
                                <span class="provider-balance__label">{{ 'common.providerBalance' | transloco }}:</span>
                                {{ provider.balance === null ? '—' : (provider.balance | appNumber: '1.2-2') + ' ' + currencySymbol(provider.currency) }}
                            </span>
                        }
                    </span>
                </button>

                @if (showProfileMenu) {
                    <div class="profile-menu" #profileMenu>
                        <div class="menu-header">
                            <div class="user-info">
                                <img [src]="userSticker" alt="" class="user-sticker" />
                                <div class="user-details">
                                    <p class="user-name">{{ userName }}</p>
                                    <p class="user-role">{{ userRoleLabel }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="menu-items">
                            <button type="button" class="menu-item" (click)="goToProfile()">
                                <lucide-icon name="Settings" [size]="24"></lucide-icon>
                                <span>{{ 'layout.profile.accountSettings' | transloco }}</span>
                            </button>
                            <button type="button" class="menu-item" (click)="logout()">
                                <lucide-icon name="LogOut" [size]="24"></lucide-icon>
                                <span>{{ 'layout.profile.logout' | transloco }}</span>
                            </button>
                        </div>
                    </div>
                }
            </div>
        }

        @if (showHamburger) {
            <button type="button" class="hamburger-button" [attr.aria-label]="'common.a11y.openMenu' | transloco" (click)="onHamburgerClick()">
                <lucide-icon name="Menu" [size]="24" aria-hidden="true"></lucide-icon>
            </button>
        }
    </div>
</div>

<!-- Profile Modal -->
<app-profile
    [visible]="profileVisible"
    (visibleChange)="onProfileVisibleChange($event)"
></app-profile>

